(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["responsive-hero-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    if (window.innerWidth >= 768) {
      const slides = document.querySelectorAll(".hero-slider__slide.desktop");
      let current = 0;
      slides.forEach((s, i) => {
      s.style.display = "none";
      s.classList.remove("active");
    });
    slides[0].style.display = "block";
    slides[0].classList.add("active");
      setInterval(() => {
        slides[current].style.display = "none";
    slides[current].classList.remove("active");
    
    current = (current + 1) % slides.length;
    
    slides[current].style.display = "block";
    slides[current].classList.add("active");
      }, 4000);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
